import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const HOME_FOR = {
  admin: "/admin",
  attorney: "/attorney",
  claimant: "/my-cases",
};

/**
 * Gate a route by auth + role.
 * - `roles`: single role string or array of allowed roles.
 *   When the user is authed but lacks the right role, redirect them to their own home.
 * - Falls back to legacy `role` prop for backward compatibility.
 */
export default function ProtectedRoute({ children, role, roles, redirectTo = "/login" }) {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-sm text-[#5C6B68]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to={redirectTo} replace />;
  const allow = roles || (role ? [role] : null);
  if (allow && !allow.includes(user.role)) {
    const home = HOME_FOR[user.role] || "/";
    return <Navigate to={home} replace />;
  }
  return children;
}
